<template>
  <vue-table :data="data" :headers="headers" :loading.sync="loading" @change="onPagination">
    <template v-slot:filters="{props, perPage}">
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" lg="3" md="4" order-md="5">
          <v-select v-model="props.length" :items="perPage" class="rounded-lg" dense hide-details label="تعداد"
                    outlined/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="4">
          <v-text-field v-model="props.search" append-icon="mdi-magnify" class="rounded-lg" clearable dense
                        hide-details label="جستجو" outlined/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="4">
          <custom-date-picker v-model="props.start_at" dense format="YYYY-MM-DD" hide-details
                              label="از تاریخ" nullable outlined type="date" wrapper-class="rounded-lg"/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="4">
          <custom-date-picker v-model="props.end_at" dense format="YYYY-MM-DD" hide-details label="تا تاریخ" nullable
                              outlined type="date" wrapper-class="rounded-lg"/>
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="4">
          <v-select v-model="props.order_by" :items="viewItems" :menu-props="{offsetY: true}" class="rounded-lg"
                    clearable dense hide-details label="بازدید کل" outlined/>
        </v-col>
      </v-row>
    </template>

    <template v-slot:index="{item}">
      {{ (item.index + 1) + ((data.current_page - 1) * data.per_page) }}
    </template>

    <template v-slot:available_at="{item}">
      <div v-html="available_filter(item.available_at)"></div>
    </template>

    <template v-slot:action="{item}">
      <v-btn :href="`#/adsList/adAnalyzer/${item.id}`" icon target="_blank">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </vue-table>
</template>

<script>
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import {Axios2} from "@/main";

export default {
  name: "adAnalyzerList",

  components: {CustomDatePicker},

  data() {
    return {
      tabs: 0,
      data: {},
      headers: [
        {value: 'index', text: 'ردیف', sortable: false, align: 'center'},
        {value: 'id', text: 'شناسه', sortable: false, align: 'center'},
        {value: 'advertise_id', text: 'شناسه آگهی‌ها', sortable: false, align: 'center'},
        {value: 'available_at', text: 'زمان آنالیز', sortable: false, align: 'center'},
        {value: 'created_at_p', text: 'تاریخ ایجاد', sortable: false, align: 'center'},
        {value: 'action', text: 'اطلاعات بازدید', sortable: false, align: 'center'},
      ],
      loading: false,
      tableProps: {
        page: 1,
        length: 10
      },
      viewItems: [
        {value: 'less', text: 'کمترین'},
        {value: 'more', text: 'بیشترین'},
      ]
    }
  },

  created() {
    this.fetchAnalyzer()
  },

  methods: {
    fetchAnalyzer(params = this.tableProps) {
      this.loading = true

      Axios2.get('divar/analysis/all', {
        params
      })
        .then(({data}) => this.data = data.data)
        .catch(({response}) => console.log('failed to get analyzer list: ', response))
        .finally(() => this.loading = false)
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e
      }

      this.fetchAnalyzer(props)
    },
    available_filter(input) {
      const moment = require('moment-jalaali')

      return moment(input).format('ddd jYYYY-jMM-jDD').split(' ').map(av => {
        return `<div>${av}</div>`
      }).join('')
    }
  }
}
</script>

<style scoped>

</style>